import React from 'react';
import BaseComponent from './components/system/base';
import './App.css';
import firebase from 'firebase';
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import { FireBaseProvider } from './context/fireBaseContext'
import UserContext from './context/userContext'
import Auth from './content/auth/auth'
import WinPrize from './content/winPrize/index'
import Banner from './components/banner'
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import jQuery from "jquery";


const $ = window;
const doc = document;

let postMessageProxy = function(message) {
  if ($.ReactNativeWebView !== undefined) {
    setTimeout(() => {
      $.ReactNativeWebView.postMessage(message);
    }, 0);
  }
}

firebase.default.initializeApp({
  apiKey: "AIzaSyB7TL6WDx_jA3wNZbVFLC2icbbCeTVoeXE",
  authDomain: "popit-234c4.firebaseapp.com",
  databaseURL: "https://popit-234c4.firebaseio.com",
  projectId: "popit-234c4",
  storageBucket: "popit-234c4.appspot.com",
  messagingSenderId: "832674601845",
  appId: "1:832674601845:web:a4c8b4d265e76d27fd913c",
  measurementId: "G-GE1DLYHFKW"
});

const theme = createMuiTheme({
  typography: {
    fontFamily: [
      '"Open Sans"',
      '"Roboto"',
      '"ヒラギノ角ゴ Pro W3"',
      '"Hiragino Kaku Gothic Pro"',
      'Osaka',
      '"メイリオ"',
      'Meiryo',
      '"ＭＳ Ｐゴシック"',
      '"MS PGothic"',
      'sans-serif',
    ].join(','),
  },
});

class App extends BaseComponent {
  constructor(props, context) {
    super(props, context);
    this.state = this.defaultUserState();
  }

  defaultUserState() {
    return {
      user: {
        info: {

        }
      }
    }
  }

  componentDidMount() {
    jQuery(doc).ready(() => {
      setTimeout(() => {
        jQuery(".firebaseui-container, .firebaseui-idp-button").bind('click', (e) => {
          jQuery("#mainFish").css({"width": "100px"});
        })
      }
      , 1000)
    });

    this.unregisterAuthObserver = firebase.auth().onAuthStateChanged((user) => {
      if (user !== undefined && user !== null) {
        $.user = {};
        $.user = user;
        this.setState({user: {isSignedIn: !!user, info: user}});
      }
    });
  }

  componentWillUnmount() {
    this.unregisterAuthObserver();
  }

  render() {
    let page = null;
    if (this.state.user.isSignedIn && !this.state.user.info.isAnonymous) {
      page = <span>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        logged in user <a onClick={() => {
          firebase.default.auth().signOut();
          this.setState(this.defaultUserState());
        }}>sign out</a>

        <button onClick={() => {
          postMessageProxy("qr")
        }}>TEST QR</button>
      </span>
    } else {
      page = <Auth/>
    }

    return (
      <Router>
        <UserContext.Provider value={{user: this.state.user}}>
          <FireBaseProvider value={{firebase: firebase}}>
            <ThemeProvider theme={theme}>
              <Banner>
                <Switch>
                  <Route path="/winPrize">
                    <WinPrize />
                  </Route>
                  <Route path="/">
                    {page}
                  </Route>
                </Switch>
              </Banner>
            </ThemeProvider>
          </FireBaseProvider>
        </UserContext.Provider>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js